"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/inherits.js"));

var _createSuper2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createSuper.js"));

var _mediaLibrary = _interopRequireDefault(require("../../client/mediaLibrary"));

var AdminMediaLibrary = /*#__PURE__*/function (_MediaLibrary) {
  (0, _inherits2["default"])(AdminMediaLibrary, _MediaLibrary);

  var _super = (0, _createSuper2["default"])(AdminMediaLibrary);

  function AdminMediaLibrary(client) {
    var _this;

    (0, _classCallCheck2["default"])(this, AdminMediaLibrary);
    _this = _super.call(this, client);
    _this.client = client;
    _this.resourceUrl = '/medias';
    return _this;
  }

  (0, _createClass2["default"])(AdminMediaLibrary, [{
    key: "getSubCategories",
    value: function getSubCategories(categoryId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/categories/").concat(categoryId, "/sub-categories"), args);
    }
  }, {
    key: "getMediasByModuleId",
    value: function getMediasByModuleId(moduleId) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.client.get("".concat(this.resourceUrl, "/module/").concat(moduleId), args);
    }
  }, {
    key: "getSignedUrlForModuleImageUpload",
    value: function getSignedUrlForModuleImageUpload(subCatId) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.client.get("".concat(this.resourceUrl, "/update-module-image/").concat(subCatId), args);
    }
  }, {
    key: "updateModuleImageBySubCatId",
    value: function updateModuleImageBySubCatId(subCatId, updateObj) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      return this.client.post("".concat(this.resourceUrl, "/update-module-image/").concat(subCatId), updateObj, args);
    }
  }, {
    key: "getMediasBySubcategoryId",
    value: function getMediasBySubcategoryId(subCategoryId) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      return this.client.get("".concat(this.resourceUrl, "/sub-categories/").concat(subCategoryId), args);
    }
  }, {
    key: "updateMedia",
    value: function updateMedia(mediaId, mediaData) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        args[_key6 - 2] = arguments[_key6];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(mediaId), mediaData, args);
    }
  }, {
    key: "createMedia",
    value: function createMedia(mediaData) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }

      return this.client.post("".concat(this.resourceUrl), mediaData, args);
    }
  }, {
    key: "getSignedUrlForUploadMedia",
    value: function getSignedUrlForUploadMedia(mediaId) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(mediaId, "/signed-url"), args);
    }
  }, {
    key: "uploadMediaStatus",
    value: function uploadMediaStatus(mediaId, mediaData) {
      for (var _len9 = arguments.length, args = new Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
        args[_key9 - 2] = arguments[_key9];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(mediaId, "/update-file-name"), mediaData, args);
    }
  }, {
    key: "deleteMediaById",
    value: function deleteMediaById(mediaId, intent) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
        args[_key10 - 2] = arguments[_key10];
      }

      return this.client["delete"]("".concat(this.resourceUrl, "/").concat(mediaId, "?intent=").concat(intent), args);
    }
  }, {
    key: "getCategoryName",
    value: function getCategoryName(categoryId, subCategoryId) {
      for (var _len11 = arguments.length, args = new Array(_len11 > 2 ? _len11 - 2 : 0), _key11 = 2; _key11 < _len11; _key11++) {
        args[_key11 - 2] = arguments[_key11];
      }

      return this.client.get("".concat(this.resourceUrl, "/category-name/").concat(categoryId, "/").concat(subCategoryId), args);
    }
  }]);
  return AdminMediaLibrary;
}(_mediaLibrary["default"]);

exports["default"] = AdminMediaLibrary;